export default "__VITE_ASSET__Bz64Xbbg__"